import m from "mithril";

type Position = {x:number, y:number};

export default class Balloon {
    static readonly MIN_INFLATION = 65;

    private color: string;
    private inflation: number = 0;
    private inflationSpeed: number;
    private released: Date|null = null;
    private ok = true;
    private animationShift: number;
    private lastPosition: Position|null = null;

    public constructor(
        private position: Position
    ) {
        //hsl(0, 100%, 50%)
        this.color = 'hsl('+ Math.floor(Math.random()*360) + ', '+
            Math.floor(Math.random()*100) + '%, ' +
            (70+Math.floor(Math.random()*30)) + '%)';

        this.inflationSpeed = 10+Math.random()*20;
        this.animationShift = -Math.random()*3;
    }

    public getInflation(): number {
        return this.inflation;
    }

    /**
     * Inflate balloon
     * true - successful inflation
     * false - balloon destroyed
     */
    public inflate(): boolean {
        if (!this.ok) {
            // Destroyed before
            return false;
        }
        if (this.released) {
            // Released before
            return true;
        }

        // Inflate!
        this.inflation += this.inflationSpeed;

        if (this.inflation > 110) {
            // You destroy balloon :'-(
            if (window.navigator.vibrate) {
                window.navigator.vibrate(70);
            }
            this.ok = false;
            return false;
        } else if (this.inflation > 100) {
            // Awesome, you got it exact full
            this.inflation = 100;
            return true;
        }
        // Hold on!
        return true
    }

    public cut(): void {
        if (!this.released) {
            this.released = new Date();
        }
    }

    public willFly(): boolean {
        return this.ok && this.inflation > Balloon.MIN_INFLATION;
    }

    public setPosition(position: {x:number, y:number}) {
        this.lastPosition = this.position;
        this.position = position;
    }

    public isOk(): boolean {
        return this.ok;
    }

    public view() {
        return m('.balloon-wrapper',
            {
                style: {
                    bottom: this.position.y+'px',
                    left: this.position.x+'px',
                    "transition-duration": this.getFlyFallDuration()+'s',
                }
            }, [
                m(this.getBalloonClass(), {
                    style: {
                        "background-color": this.color,
                        width: (this.inflation+10)+'px',
                        height: (1.2*this.inflation+20)+'px',
                        opacity: this.getOpacity(),
                        "animation-delay": this.animationShift+'s',
                    }
                }),
                this.released ? m('.string', {}, ' ') : null,
            ]
        )
    }

    private getBalloonClass(): string {
        let htmlClass = '.balloon';
        if (this.released) {
            htmlClass += this.willFly() ? '.fly' : '.fall'
        }
        htmlClass += this.willFly() ? '.ready' : '';
        htmlClass += this.ok ? '' : '.exploded';
        return htmlClass;
    }

    /**
     * Return fly duration in seconds
     */
    private getFlyFallDuration(): number {
        if (this.willFly()) {
            return (Balloon.MIN_INFLATION+2500)/(this.inflation - Balloon.MIN_INFLATION + 300);
        } else {
            return 1.2;
        }

    }

    private getOpacity(): number {
        if (this.inflation < Balloon.MIN_INFLATION) {
            return 1;
        } else {
            return 1 - (this.inflation-Balloon.MIN_INFLATION)/(100-Balloon.MIN_INFLATION)*0.3
        }
    }

}